import amaLog from "../helpers/log";

export const AD_LOADED_ATTRIBUTE = 'data-aller-ad-loaded';

export const AD_PLACEMENT_ATTRIBUTE = 'data-aller-ad-placement';

export const setAdLoadedForDiv = (divId: string) => {
  document.getElementById(divId).setAttribute(AD_LOADED_ATTRIBUTE,'');  
};

export const setAdLoadedForElement = (div: HTMLElement) => {
  div.setAttribute(AD_LOADED_ATTRIBUTE,'');
};

export const resolveTarget = (placement: string, config: IAdsConfig, element: HTMLElement): string | undefined => {
  if (!placement || !config || !element) return;

  // First, try to find direct match
  const directMatch = config.ads?.some((ad: IAdRaw) => placement === ad.target );

  directMatch && amaLog(`resolveTarget directMatch for ${placement}`);

  if (directMatch) return placement;

  const xSlotname = `${placement.split("_")[0]}${placement.startsWith("intext") ? "_ad_x" : "_x"}`;

  // Otherwise, try to find x-match
  const xMatch = config.ads?.find((ad: IAdRaw) => xSlotname.toLowerCase() === `${ad.target}`.toLowerCase() );
  
  if (xMatch) {
    element.setAttribute(AD_PLACEMENT_ATTRIBUTE, xMatch.target);
    return xMatch.target;
  }
};

